import React, { Component } from 'react';
import ThreeOptions from './ThreeOptions';

class Step9 extends Component {
    render() {
        return (

            <div className="card card-body">
                <div className="form-group">
                    <div className="h5">EMERGENCY POWER SUPPLY TEST AND INSPECTION</div>
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="emergBatteryType"
                        label="Correct Battery Type as Recommended by Manufacturer"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="emergBatteryRating"
                        label="Correct Rating in conformance with the Equipment Listing"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="emergChargeOn">Battery Charging Voltage Primary Power ‘On’</label>
                    <div className="input-group">
                        <input id="emergChargeOn" name="emergChargeOn" type="text" required="required" className="form-control here" />
                        <div className='input-group-append'>
                            <span className='input-group-text'>V</span>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="emergChargeCurrent">Battery Charging Current</label>
                    <div className="input-group">
                        <input id="emergChargeCurrent" name="emergChargeCurrent" type="text" required="required" className="form-control here" />
                        <div className='input-group-append'>
                            <span className='input-group-text'>mA</span>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="emergChargeOff">Battery Charging Voltage Primary Power ‘Off’</label>
                    <div className="input-group">
                        <input id="emergChargeOff" name="emergChargeOff" type="text" required="required" className="form-control here" />
                        <div className='input-group-append'>
                            <span className='input-group-text'>V</span>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="emergDrawOff">Current Draw from Battery Primary Power ‘Off”</label>
                    <div className="input-group">
                        <input id="emergDrawOff" name="emergDrawOff" type="text" required="required" className="form-control here" />
                        <div className='input-group-append'>
                            <span className='input-group-text'>mA</span>
                        </div>
                    </div>
                </div>


                <div className="form-group">
                    <div className="row">
                        <div className='col-sm-12 col-md-5'>Measured Amp/hour Rating of Battery</div>
                        <div className="col-sm-12 col-md-2">
                            <div className="form-group">
                                <label htmlFor="emergQuantities">Quantities:</label>
                                <input id="emergQuantities" name="emergQuantities" type="text" required="required" className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <div className="form-group">
                                <label htmlFor="emergVoltage">Voltage</label>
                                <input id="emergVoltage" name="emergVoltage" type="text" required="required" className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <div className="form-group">
                                <label htmlFor="emergAmpH">Ah</label>
                                <input id="emergAmpH" name="emergAmpH" type="text" required="required" className="form-control here" />
                            </div>
                        </div>
                        <div class="col-md-7"></div>
                        <div className="col-sm-12 col-md-2">
                            <div className="form-group">
                                <label htmlFor="emergVoltage1">Voltage</label>
                                <input id="emergVoltage1" name="emergVoltage1" type="text" className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <div className="form-group">
                                <label htmlFor="emergAmpH1">Ah</label>
                                <input id="emergAmpH1" name="emergAmpH1" type="text" className="form-control here" />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="aH24Mult">Amp/hour rating required: 24 x Current Draw in amps =</label>
                    <div className="input-group">
                        <input id="aH24Mult" name="aH24Mult" type="text" required="required" className="form-control here" />
                        <div className='input-group-append'>
                            <span className='input-group-text'>Ah</span>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <ThreeOptions
                        name="emergBattSufficient"
                        label="Battery will provide 24 h emergency power?"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="emergBattInsp"
                        label="Inspected For Physical Damage"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="emergBattTerms"
                        label="Terminals Clamped Tightly"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="emergBattMMYY">Battery Manufacturer’s Date Code / Installation Date</label>
                    <div className="input-group">
                        <input id="emergBattMMYY" name="emergBattMMYY" type="text" required="required" className="form-control here" />
                        <div className='input-group-append'>
                            <span className='input-group-text'>MM/YY</span>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <ThreeOptions
                        name="emergDiscTrouble"
                        label="Disconnection Causes Trouble Signal"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="emergCorrectRating"
                        label="Correct rating as determined by battery calculations based on full system load"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="emergRemarks">REMARKS</label>
                    <textarea id="emergRemarks" name="emergRemarks" cols="40" rows="5" className="form-control"></textarea>
                </div>

            </div>
        );
    }
}

const labelStyle = {
    marginleft: '-20px'
}
export default Step9;



// WEBPACK FOOTER //
// ./src/components/Step9.js